import { Routes } from "@angular/router";

import { authGuard, cardAvailabilityGuard, cardIdGuard, dashboardIdGuard, dashboardRedirectGuard } from "@shared/index";
import { ViewComponent } from "./view-components/view-component/view.component";

// Only one view is ever displayed at a time and the card modal only opens on demand, so each is
// loaded lazily. Imports point at concrete files rather than barrels, which would pull every
// sibling view back into the initial bundle.
const loadActiveView = () => import("./view-components/active-view-component/active-view.component").then((m) => m.ActiveViewComponent);
const loadCardModal = () => import("./card-modal-component/card-modal.component").then((m) => m.CardModalComponent);

export const appRoutes: Routes = [
    {
        path: "card-view",
        canActivate: [authGuard],
        component: ViewComponent,
        children: [
            {
                path: "",
                canActivate: [dashboardRedirectGuard],
                children: [],
            },
            {
                path: ":dashboardId",
                canActivate: [dashboardIdGuard],
                children: [
                    {
                        path: "find",
                        loadComponent: loadActiveView,
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardIdGuard],
                                loadComponent: loadCardModal,
                            },
                        ],
                    },
                    {
                        path: "active",
                        loadComponent: loadActiveView,
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                loadComponent: loadCardModal,
                            },
                        ],
                    },
                    {
                        path: "not-started",
                        loadComponent: () =>
                            import("./view-components/not-started-component/not-started.component").then((m) => m.NotStartedComponent),
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                loadComponent: loadCardModal,
                            },
                        ],
                    },
                    {
                        path: "completed",
                        loadComponent: () =>
                            import("./view-components/completed-view-component/completed-view.component").then((m) => m.CompletedViewComponent),
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                loadComponent: loadCardModal,
                            },
                        ],
                    },
                    {
                        path: "all",
                        loadComponent: () =>
                            import("./view-components/all-view-container/all-view-container.component").then((m) => m.AllViewContainerComponent),
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                loadComponent: loadCardModal,
                            },
                        ],
                    },
                    {
                        path: "assignees-view",
                        loadComponent: () =>
                            import("./view-components/assignees-view/assignees-view.component").then((m) => m.AssigneesViewComponent),
                        children: [
                            {
                                path: ":cardId",
                                canActivate: [cardAvailabilityGuard],
                                loadComponent: loadCardModal,
                            },
                        ],
                    },
                    { path: "", redirectTo: "active", pathMatch: "full" },
                ],
            },
        ],
    },
    {
        path: "settings",
        canActivate: [authGuard],
        loadChildren: () => import("./settings-components/settings.routes").then((m) => m.settingsRoutes),
    },
    {
        path: "accessdenied",
        loadComponent: () => import("./access-denied/access-denied.component").then((m) => m.AccessDeniedComponent),
    },
    {
        path: "accessdenied/:lang",
        loadComponent: () => import("./access-denied/access-denied.component").then((m) => m.AccessDeniedComponent),
    },
    {
        path: "accessunauthorized",
        loadComponent: () => import("./access-unauthorized/access-unauthorized.component").then((m) => m.AccessUnauthorizedComponent),
    },
    {
        path: "accessunauthorized/:lang",
        loadComponent: () => import("./access-unauthorized/access-unauthorized.component").then((m) => m.AccessUnauthorizedComponent),
    },
    {
        path: "unauthorizedroute",
        loadComponent: () => import("./unauthorized-route/unauthorized-route.component").then((m) => m.UnauthorizedRouteComponent),
    },
    {
        path: "dev-tools",
        loadComponent: () => import("./dev-tools/dev-tools.component").then((m) => m.DevToolsComponent),
    },
    { path: "", redirectTo: "card-view", pathMatch: "full" },
    { path: "**", redirectTo: "card-view", pathMatch: "full" },
];
